import Vue from 'vue'
import moment from 'moment'
import VueMoment from 'vue-moment'
import 'moment/locale/ru'

Vue.use(VueMoment, {
  moment
})

export default {
  state: {
    form: {}
  },
  actions: {
    setForm (context, values) {
      context.commit('setForm', values)
    },
    deleteForm (context) {
      context.commit('deleteForm')
    }
  },
  mutations: {
    setForm (state, values) {
      state.form[values.id] = []
      values.medData = {}
      state.form[values.id].push(values)

      for (let key in state.form[values.id][0].medical_data) {
        if (key === 'lod') {
          values.medData[key] = state.form[values.id][0].medical_data[key]
          values.medData[key].forEach(item => {
            item.date = moment(item.date, 'YYYY-MM-DD').format('DD.MM.YYYY')
          })
        } else if (key === 'opened_case') {
          if (state.form[values.id][0].medical_data[key].diagnoses) {
            values.medData[key] = state.form[values.id][0].medical_data[key]
            if (!!values.medData[key].opened_date) {
              values.medData[key].opened_date = moment(
                values.medData[key].opened_date
              ).format('DD.MM.YYYY')
            }
            values.medData[key].diagnoses.forEach(item => {
              item.date = moment(item.date, 'YYYY-MM-DD').format('DD.MM.YYYY')
            })
          } else {
            values.medData[key] = {
              diagnoses: [],
              drugs: state.form[values.id][0].medical_data[key].drugs
            }
          }
        } else {
          if (state.form[values.id][0].medical_data[key][0]) {
            values.medData[key] =
              state.form[values.id][0].medical_data[key][0].value
          }
        }
      }
    },
    deleteForm (state) {
      state.form = {}
    }
  },
  getters: {}
}
